import { render, staticRenderFns } from "./Headbar.vue?vue&type=template&id=2ae028c2&scoped=true"
import script from "./Headbar.vue?vue&type=script&lang=js"
export * from "./Headbar.vue?vue&type=script&lang=js"
import style0 from "./Headbar.vue?vue&type=style&index=0&id=2ae028c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae028c2",
  null
  
)

export default component.exports